import React from "react";
import { motion } from "framer-motion";
import { Landmark, ArrowRight } from "lucide-react";
import { BIZ, SLUG, PRACTICE_AREAS } from "./trenasData";
import TrenasLayout, { NAVY, GOLD, CREAM, SLATE } from "./TrenasLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function TrenasHome() {
  const basePath = `/${SLUG}`;
  return (
    <TrenasLayout active="home">
      {/* HERO — the firm's real office wall, showing its own name history */}
      <section className="relative min-h-[74vh] flex items-end" data-testid="trenas-hero">
        <img src="/law/trenas-law-iloilo-concept/office-heritage-wall.jpg" alt="The Treñas Law Offices heritage wall in Iloilo, showing the firm's history of names since 1918" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(11,31,69,0.2) 0%, rgba(11,31,69,0.6) 55%, rgba(11,31,69,0.96) 100%)" }} />
        <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 w-full pb-14">
          <motion.div {...fadeUp} className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: GOLD }}>Iloilo City · Established 1918</span>
            <h1 className="mt-5 text-4xl sm:text-5xl trenas-serif text-white leading-[1.15]">A Legacy of Legal Practice in Iloilo</h1>
            <p className="mt-5 text-white/80 max-w-xl">Civil, commercial, criminal, family, tax and property law — we trace our Iloilo lineage back to 1918, and are now an affiliate of DivinaLaw.</p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href={`${basePath}/contact`} data-testid="trenas-hero-cta" className="rounded-md px-7 py-3.5 text-sm font-semibold" style={{ background: GOLD, color: NAVY }}>Request a Consultation</a>
              <a href={`${basePath}/history`} data-testid="trenas-hero-history" className="inline-flex items-center gap-2 rounded-md px-7 py-3.5 text-sm font-semibold text-white border border-white/30">Our History <ArrowRight size={16} /></a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* PRACTICE AREAS TEASER — an archival index/ledger list, not a card grid */}
      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-2xl mx-auto px-5 sm:px-8">
          <motion.h2 {...fadeUp} className="trenas-serif text-3xl text-center mb-3" style={{ color: NAVY }}>Practice Areas</motion.h2>
          <motion.p {...fadeUp} className="text-center text-xs uppercase tracking-[0.2em] mb-10" style={{ color: GOLD }}>An Index of Our Work</motion.p>
          <div style={{ borderTop: `1px solid rgba(11,31,69,0.15)` }}>
            {PRACTICE_AREAS.slice(0, 5).map((s, i) => (
              <motion.div key={s.title} {...fadeUp} className="flex items-baseline justify-between gap-4 py-4" style={{ borderBottom: "1px solid rgba(11,31,69,0.15)" }}>
                <span className="trenas-serif text-base" style={{ color: NAVY }}>{s.title}</span>
                <span className="trenas-serif text-sm shrink-0" style={{ color: GOLD }}>{String(i + 1).padStart(2, "0")}</span>
              </motion.div>
            ))}
          </div>
          <motion.div {...fadeUp} className="text-center mt-8">
            <a href={`${basePath}/practice-areas`} data-testid="trenas-see-all-practice" className="inline-flex items-center gap-2 text-sm font-semibold" style={{ color: NAVY }}>See all practice areas <ArrowRight size={15} /></a>
          </motion.div>
        </div>
      </section>

      {/* DIVINALAW STRIP */}
      <section className="py-14" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <Landmark size={26} style={{ color: GOLD }} className="mx-auto mb-4" />
          <motion.p {...fadeUp} className="text-white/85 text-base">We're currently listed as an Iloilo affiliate of DivinaLaw. <a href={`${basePath}/history`} className="underline" style={{ color: GOLD }}>Read more about our history</a>.</motion.p>
        </div>
      </section>
    </TrenasLayout>
  );
}
